import React from 'react';
import { Tooltip } from '@wix/design-system';

interface Props {
  dataHook: string;
  content: string;
  children: React.ReactNode;
}

export const DisabledCtaTooltip = ({ dataHook, content, children }: Props) => (
  <Tooltip dataHook={dataHook} content={content} placement="top" inline={true} textAlign="center">
    <span>{children}</span>
  </Tooltip>
);
